<template>
  <div class="max-w-4xl w-full mx-auto mb-8">
    <div class=" text-lg font-bold mb-6 black-text mt-8">
      {{ orderHeading }}
    </div>
    <div class="order-table table-container p-3">
      <div class="order-table-header flex justify-between py-3">
        <div class="">Product Name</div>
        <div class="">Quantity</div>
        <div class="">Total (AUD)</div>
      </div>
      <div 
        v-for="(row, index) in orderRows" 
        :key="index"
        class="order-table-body flex items-center py-3"
      >
        <div class="flex-1">{{ row.name }}</div>
        <div class="flex-1 text-center">{{ row.quantity }}</div>
        <div class="flex-1 text-right">${{ (row.price * row.quantity) / 100 }}</div>
      </div>

      <div class="order-table-total black-text flex justify-between py-3">
        <div class="">Total</div>
        <div class="">${{ totalAmount }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderCard',
  props: {
    orderRows: {
      type: Array,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
    decision: { // the link's decision: 'approved' or 'rejected'
      type: String,
      default: null,
    },
  },
  computed: {
    orderHeading() {
      if (this.status === 'approved') return 'Order Submitted:';
      if (this.status === 'rejected') return 'Inventory Forecast:';
      if (this.status === 'pending') {
        return this.decision === 'rejected' ? 'Inventory Forecast:' : 'Requested Order:';
      }
      return '';
    },
    totalAmount() {
      const amount = this.orderRows.reduce((acc, row) => acc + (row.price * row.quantity) / 100, 0);
      return amount.toFixed(2);
    },
  },
};
</script>

<style scoped>
.custom-border{
  border-radius: 12px;
  border: 1px solid #E3E3E3; 
}

.order-table .vs-con-table .vs-con-tbody {
  background-color: transparent !important;
  border: 0 !important;
}

.order-table-header {
  border-bottom: 1px solid #969696;
}

.order-table-body {
  border-bottom: 1px solid #E3E3E3;
}

.order-table-total {
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.18px;
}
.black-text {
  color: #262928;
}

.header-text {
  color: #232323;
  font-size: 18px;
  font-weight: 600;
  line-height: 32px;
}
.table-container {
  border-radius: 8px;
  background: #FAFAFA;
}
</style> 